<template>
    <div class="scope-resume-detail">
        <div class="fixed-bar">
            <div style="margin-left: 230px;margin-right: 30px;">
                <el-row type="flex" justify="space-between" align="middle">
                    <el-col :span="10">
                        <h1 class="fixed-bar-title pull-left" v-if="personalData.name">{{personalData.name
                            }} - {{positionData.name}}</h1>
                        <div class="pull-left">
                            <template v-if="!isEdit">
                                <el-button type="success" @click="isEdit = !isEdit">编辑</el-button>
                                <el-button
                                    v-if="showCloseBtn"
                                    type="primary"
                                    plain=""
                                    @click="$win.close"
                                >关闭</el-button>
                            </template>
                            <template v-else>
                                <el-button type="success" @click="submitAll" class="f-edit">保存</el-button>
                                <el-button class="f-edit" @click="cancelEdit">取消</el-button>
                            </template>
                        </div>
                    </el-col>
                    <el-col :span="14">
                        <el-row type="flex" justify="end">
                            <template v-if="from === 'entryList'">
                                <el-button icon="el-icon-my-queding color-success" type="success" :plain="true"
                                           @click="changeStatus(id,'pass', null, '入职')">入职
                                </el-button>
                                <el-button icon="el-icon-my-guanbi color-danger" type="danger" :plain="true"
                                           @click="changeStatus(id,'notPass', null, '毁约')">毁约
                                </el-button>
                                <el-button icon="el-icon-my-huitui color-info" type="info" :plain="true"
                                           @click="changeStatus(id,'back')">回退
                                </el-button>
                            </template>
                            <template v-else-if="from === 'interviewList'||from === 'resumeList'">
                                <el-button icon="el-icon-my-queding color-success" type="success" :plain="true"
                                           @click="changeStatus(id,'pass')">通过
                                </el-button>
                                <el-button icon="el-icon-my-daiding color-warning" type="warning" :plain="true"
                                           @click="changeStatus(id,'undetermined')">待定
                                </el-button>
                                <el-button icon="el-icon-my-guanbi color-danger" type="danger" :plain="true"
                                           @click="changeStatus(id,'notPass')">淘汰
                                </el-button>
                                <el-button icon="el-icon-my-lahei color-purple" type="purple" :plain="true"
                                           @click="changeStatus(id,'lh')">拉黑
                                </el-button>
                                <el-button v-if="basePath === '/employ'" @click="changeStatus(id,'fq')"
                                           icon="el-icon-my-guanbi color-danger"
                                           type="danger" :plain="true">放弃
                                </el-button>
                                <el-button icon="el-icon-my-huitui color-info" type="info" :plain="true"
                                           @click="changeStatus(id,'back')">回退
                                </el-button>
                                <el-button v-if="basePath === '/employ'" icon="el-icon-my-queding color-success" type="success"
                                           :plain="true"
                                           @click="changeStatus(id,'entry')">进入入职
                                </el-button>
                                <!--<el-button v-if="basePath === '/payment'" icon="el-icon-my-queding color-success" type="success"-->
                                           <!--:plain="true"-->
                                           <!--@click="changeStatus(id,'entry')">进入定薪-->
                                <!--</el-button>-->
                                <el-button icon="el-icon-my-daochu color-info" type="info" :plain="true" @click="exportFile">
                                    导出简历
                                </el-button>
                            </template>
                            <template v-else-if="from === 'paymentList'">
                                <el-button icon="el-icon-my-queding color-success" type="success" :plain="true"
                                           @click="changeStatus(id,'pass')">接受Offer
                                </el-button>
                                <el-button icon="el-icon-my-guanbi color-danger" type="danger" :plain="true"
                                           @click="changeStatus(id,'fq')">放弃Offer
                                </el-button>
                                <el-button icon="el-icon-my-huitui color-info" type="info" :plain="true"
                                           @click="changeStatus(id,'back')">回退
                                </el-button>
                                <el-button icon="el-icon-my-lahei color-purple" type="info" :plain="true"
                                           @click="changeStatus(id,'lh')">拉黑
                                </el-button>
                                <el-button icon="el-icon-my-daochu color-info" type="info" :plain="true" @click="exportFile">
                                    导出简历
                                </el-button>
                            </template>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
        </div>
        <el-row :gutter="20">
            <el-col :span="17" :class="[{ 'form-view': !isEdit }, 'form-switch']">
                <div class="box-shadow-small border-radius">
                    <personal-module ref="personalModule" :data="personalData" :key="preventKey+1" :class="{'module-view': !isEdit}"></personal-module>
                    <education-module ref="educationModule" :data="educationData" :key="preventKey+2" :class="{'module-view': !isEdit}"></education-module>
                    <item-module ref="workModule" type="work" :multiple="true" :data="personalData.resumeWorkList"
                                 :key="preventKey+3" :class="{'module-view': !isEdit}"></item-module>
                    <item-module ref="projectModule" type="project" :multiple="true"
                                 :data="personalData.resumeProjectList" :key="preventKey+4" :class="{'module-view': !isEdit}"></item-module>
                    <item-module ref="skillModule" type="skill" :multiple="true" :data="personalData.resumeITSkillList"
                                 :key="preventKey+5" :class="{'module-view': !isEdit}"></item-module>
                    <item-module ref="experienceModule" type="experience" :multiple="true"
                                 :data="personalData.resumeGameExperienceList" :key="preventKey+6" :class="{'module-view': !isEdit}"></item-module>
                    <attach-module ref="attachModule" :data="attachData" :rid="rid" :class="{'module-view': !isEdit}"></attach-module>
                </div>
            </el-col>
            <el-col :span="7">
                <div class="box-shadow-small border-radius">
                    <div class="flow-step-module">
                        <h1 class="module-title">操作流转记录</h1>
                        <div class="mt-20 flow-lists scrollbar-beauty">
                            <el-steps :space="100" direction="vertical" v-if="flowList.length">
                                <el-step title="" icon="el-icon-self-circle-icon" v-for="(item, index) in flowList"
                                         :key="index">
                                    <div slot="description" class="flow-info-box">
                                        <p v-if="item.newPositionName || item.positionName" class="title">
                                            职位从 <span style="color: #8c939d">{{item.positionName}}</span> 变为 <span
                                                class="color-primary">{{item.newPositionName}}</span></p>
                                        <p v-else class="title">
                                            从 <span
                                                style="color: #8c939d">{{getSelectMapText('WB_FLOW_STATUS', item.oldStatus) || '无'}}</span>
                                            {{getStateDirect(item.oldStatus, item.newStatus)}} <span
                                                class="color-success">{{getSelectMapText('WB_FLOW_STATUS', item.newStatus)}}</span>
                                        </p>
                                        <div class="clearfix ext-info" style="width: 100%;">
                                            <p style="float: left">{{item.operateTime}}</p>
                                            <p style="float: right">操作者：{{item.operatUser.name}}</p>
                                        </div>
                                    </div>
                                </el-step>
                            </el-steps>
                            <div v-else style="color: #c4c4c4;text-align: center;">
                                暂无数据
                            </div>
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>
<script type="text/javascript">
    import PersonalModule from './personalModule'
    import EducationModule from './educationModule'
    import AttachModule from './attachModule'
    import ItemModule from './itemModule'
    import operationMixin from '../operation/operationMixin'
    import Sticky from 'directives/vue-sticky'
    import selectMapMixin from 'mixins/selectMapMixin'

    export default {
        mixins: [operationMixin, selectMapMixin],
        data () {
            return {
                urls: {
                    fetch: '/resumePosition/detail.api',
                    save: '/resume/update.api'
                },
                lists: [],
                flowList: [],
                personalData: {
                    resumeWorkList: []
                },
                positionData: {},
                educationData: [],
                attachData: [],
                preventKey: 1,
                rid: '',
                isEdit: false,
                showCloseBtn: !!window.opener // 地址栏敲击访问详情页时隐藏关闭按钮
            }
        },
        computed: {
            id () {
                return this.$route.params.id
            },
            from () {
                return this.$route.query.fromName
            }
        },
        methods: {
            submitAll () {
                let postData = {},
                    isEducationOK,
                    isPersonalOK,
                    isWorkOK,
                    itemMap = {
                        work: 'works',
                        project: 'projects',
                        skill: 'itSkills',
                        experience: 'gameExperiences'
                    },
                    okArr = []
                // 个人信息
                this.$refs.personalModule.$refs.personal.saveData('ruleForm', (data) => {
                    isPersonalOK = !!data
                    postData = data
                })
                // 教育经历
                this.$refs.educationModule.saveAllEducation((data) => {
                    postData.edus = JSON.stringify(data)
                    isEducationOK = this.$refs.educationModule.isPass
                })
                Object.keys(itemMap).forEach(key => {
                    this.$refs[`${key}Module`].saveAll((data) => {
                        postData[itemMap[key]] = JSON.stringify(data)
                        okArr.push(this.$refs[`${key}Module`].isPass)
                        console.log(`${key}:`, postData[itemMap[key]], okArr)
                    })
                })
                // 附件信息
                this.$refs.attachModule.$refs.attach.saveData((data) => {
                    let attachArr = data.map((item, index) => {
                        return {
                            resumeId: item.resumeId,
                            fileId: item.fileId,
                            md5: item.md5
                        }
                    })

                    postData.attachs = JSON.stringify(attachArr)
                })

                if (isPersonalOK && isEducationOK && okArr.indexOf(false) === -1) {
                    this.$axios.post(this.urls.save, postData, {'X-showMessage': true}).then(res => {
                        this.editData()
                        this.setInitData(res.result.bean)
                        this.lists = [res.result.bean]
                    }).catch(() => {})
                }
            },
            editData () {
                this.isEdit = !this.isEdit
            },
            cancelEdit () {
                this.editData()
                this.$refs.personalModule.$refs.personal.resetForm('ruleForm')
                this.$refs.educationModule.resetAllEducation()
                this.fetchData()
            },
            setInitData (data) {
                this.rid = data.resumeForm.id
                this.personalData = data.resumeForm
                this.positionData = data.positionForm
                this.personalData.positionId = data.positionForm.id + ''
                this.educationData = data.resumeForm.resumeEducationList
                this.attachData = data.resumeForm.resumeAttachList
            },
            fetchData () {
                this.$axios.post(this.urls.fetch, {id: this.id}).then(res => {
                    this.setInitData(res.result.bean)
                    this.lists = [res.result.bean]
                }).catch(() => {})
                this.$axios.get('/resumePosition/flowList.api?resumePositionId=' + this.id).then(res => {
                    this.flowList = res.result.list
                })
            },
            exportFile () {
                window.open(`${this.$axios.defaults.baseURL}/resume/exportResumeDetail.api?id=${this.id}&token=${this.$store.state.app.token}`)
            },
            getStateDirect (oldState, newState) {
                if (oldState.length && newState.length) {
                    let oldPhase = parseInt(oldState.slice(1, 2)),
                        newPhase = parseInt(newState.slice(1, 2))
                    if (oldPhase > newPhase && !(oldPhase === 5 && newPhase === 4)) {
                        return '回退到'
                    }
                }
                return '变为'
            }
        },
        created () {
            this.fetchData()
        },
        directives: {
            Sticky
        },
        components: {
            PersonalModule,
            EducationModule,
            AttachModule,
            ItemModule
        }
    }
</script>
<style type="text/css" lang="scss">
    @import "~variable";

    .scope-resume-detail {
        margin-top : $padding-width + 20;
        .fixed-bar {
            padding    : 10px 0;
            position   : fixed;
            left       : 0;
            z-index    : 9;
            width      : 100%;
            top        : $main-header-height;
            background : rgba(36, 129, 255, .6);
            .fixed-bar-title {
                line-height  : 36px;
                font-size    : 16px;
                color        : #fff;
                margin-right : 30px;
            }
        }

        .item-divider {
            position : relative;
            padding-top: 20px;
            &:not(:last-child) {
                margin-bottom : 10px;
                border-bottom : 1px solid $border-color;
            }
            .remove-btn {
                position : absolute;
                right    : 0;
                top      : 10px;
            }
        }

        .module-title {
            font-size      : 18px;
            border-bottom  : 1px solid #f2f5f9;
            padding-bottom : 5px;
            margin-bottom  : 5px;
        }
        .resume-item-module {
            padding : 30px 0 0;
            .form-switch {
                padding : 20px 0;
            }
            &.module-view {
                padding : 30px 30px 0!important;
                .form-switch {
                    padding : 20px 140px!important;
                }
            }
        }
        .flow-step-module {
            padding   : 30px 15px;
            min-width : 300px;
            .flow-lists {
                height     : 600px;
                overflow-y : auto;

            }
            .el-step__head {
                width       : 20px;
                height      : 20px;
                line-height : 20px;
            }
            .el-step__main {
                width : 80%;
            }
            .el-step__line.is-vertical {
                left : 9px;
            }
            .el-step__line.is-vertical {
                top : 18px;
            }
            .el-step__line-inner {
                display : none;
            }
            .el-step__icon {
                width  : 100%;
                height : 100%;
            }
            .el-icon-self-circle-icon {
                background    : #c7d9ed;
                border-radius : 200%;
                display       : block;
                width         : 100%;
                height        : 100%;
                position      : relative;
            }
            .el-step__icon:after {
                display       : block;
                width         : 10px;
                height        : 10px;
                background    : #fff;
                position      : absolute;
                left          : 5px;
                top           : 5px;
                z-index       : 2;
                content       : "";
                border-radius : 200%;
            }
            .flow-info-box {
                border        : 1px solid #e2e7eb;
                max-width     : 300px;
                padding       : 5px 10px;
                box-sizing    : border-box;
                line-height   : 28px;
                border-radius : 5px;
                .title {
                    font-size : 14px;
                    color     : #666;
                }
                .ext-info {
                    color : #c7d9ed;
                }
            }
            .el-step:last-child {
                .el-icon-self-circle-icon {
                    background : #2481ff;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// resumeDetail.vue?d2e7d04a